import globalAxios from "../GlobalAxios";

const listApi = async () => {
  try {
    const res = await globalAxios.get('/api/encodingserver/list');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const deleteApi = async (data) => {
  try {
    const res = await globalAxios.delete('/api/encodingserver/delete', { data });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const addApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/encodingserver/create', data);
    return res;
  } catch (error) {
    console.error("error", error);
  }
}

const statusChangeApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/encodingserver/changestatus', data);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}




export default {
  listApi,
  deleteApi,
  addApi,
  statusChangeApi
};